import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ContactForm from '@/components/feature/ContactForm';
import SEOHead from '@/components/feature/SEOHead';
import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <>
      <SEOHead
        title="Contact & Devis gratuit | DFPRO Lyon"
        description="Contactez DFPRO Lyon pour un dépannage de volet roulant ou fenêtre à Lyon. Devis gratuit, intervention 24-48h, 7j/7."
        canonicalUrl="https://depanfenetres-lyon.fr/contact/"
      />
      <Header />

      <main className="pt-20 pb-16">
        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-secondary-400 mb-6 flex-wrap">
              <Link to="/" className="hover:text-primary-500 transition-colors">Accueil</Link>
              <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center"></i>
              <span className="text-secondary-500">Contact</span>
            </nav>
            <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-800">Contact & devis gratuit</h1>
            <p className="mt-4 text-sm md:text-lg text-secondary-500 max-w-3xl leading-relaxed">
              Une panne de volet roulant, une fenêtre à réparer ? Contactez-nous par téléphone ou remplissez le formulaire ci-dessous. Nous vous répondons rapidement.
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <div>
                <h2 className="font-heading font-semibold text-xl text-foreground-800 mb-6">Envoyez-nous votre demande</h2>
                <ContactForm />
              </div>

              <div className="space-y-8">
                <div>
                  <h2 className="font-heading font-semibold text-xl text-foreground-800 mb-6">Contact direct</h2>
                  <div className="space-y-5">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-md bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-fill text-accent-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <h3 className="font-heading font-semibold text-sm text-foreground-800">Téléphone</h3>
                        <a href="tel:+33980803684" className="text-sm text-primary-500 hover:text-primary-600 font-medium">09 80 80 36 84</a>
                        <p className="text-xs text-secondary-400 mt-1">Disponible 7j/7 de 7h à 21h</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-md bg-primary-50 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <h3 className="font-heading font-semibold text-sm text-foreground-800">Email</h3>
                        <a href="mailto:lyon@dfpro.fr" className="text-sm text-primary-500 hover:text-primary-600 font-medium">lyon@dfpro.fr</a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-md bg-primary-50 flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <h3 className="font-heading font-semibold text-sm text-foreground-800">Zone d'intervention</h3>
                        <p className="text-sm text-secondary-500">Lyon (1er au 9e) et toute la Métropole de Lyon</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 rounded-lg p-5 md:p-6">
                  <h3 className="font-heading font-semibold text-sm text-foreground-800 mb-3">Pourquoi nous appeler ?</h3>
                  <ul className="space-y-2.5">
                    {[
                      'Devis gratuit et sans engagement',
                      'Intervention sous 24 à 48 heures',
                      'Garantie 10 ans sur toutes les réparations',
                      'Techniciens qualifiés, toutes marques',
                      'Intervention 7j/7, de 7h à 21h',
                    ].map((item, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-secondary-500">
                        <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 w-4 h-4 flex-shrink-0 flex items-center justify-center"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-primary-500 rounded-lg p-5 md:p-6 text-center">
                  <p className="font-heading font-semibold text-sm text-background-50 mb-3">Besoin d'un dépannage urgent ?</p>
                  <a
                    href="tel:+33980803684"
                    className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm px-5 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-fill w-4 h-4 flex items-center justify-center"></i>
                    Appeler le 09 80 80 36 84
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}